/*
 * @Author: cn1994
 * @Date: 2024-04-15 15:50:24
 * @LastEditors: cn1994
 * @LastEditTime: 2024-12-12 16:54:25
 * @Description: file content
 */
/*
 * @Description: 特殊机构账号登录
 */
import { useBaseStore } from "@/stores/base";
const baseStore = useBaseStore();
let mixin = {
  data(){
    return {}
  },
  computed: {
    // 是否为特殊账号
    isSpecialInst() {
      return (username) => {
        let instArr = ['adminzhihui','adminexam','admindubbing','adminshuji','adminlingshi', 'admincontent'];
        let filterResult = instArr.find(f => username.includes(f))
        if (filterResult) {
          return true
        } else {
          return false
        }
      }
    },
    // 特殊账号匹配的server
    serverLink() {
      if(this.isSpecialInst) {
        let locationHost = location.host;
        let s2 = 'gc';
        let gc = 'school';
        let vs = 'stage2';
        let xs = 'pre';
        if(locationHost.includes(s2) || locationHost.includes(gc)) {
          return 's2.51tyty.com';
        } else if(locationHost.includes(vs)) {
          return 'stage2.51tyty.com'
        } else if(locationHost.includes(xs)) {
          return 'pre.51tyty.com'
        } else if(process.env.NODE_ENV === "development") {
          if(baseStore.baseDomain.includes(s2) || baseStore.baseDomain.includes(gc)) {
            return 's2.51tyty.com';
          } else if(baseStore.baseDomain.includes(xs)) {
            return 'pre.51tyty.com'
          } else if(baseStore.baseDomain.includes('oss')) {
            return 'stage2.51tyty.com'
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },
  methods: {
  }
}

export default mixin